import { createApi } from '@/api'
export default {
	getTourList: config => createApi( `/tourElder/pageSearch`, 'post', config ),
	tourDetail: config => createApi(`/tourElder/get`, 'get', config),
	addtour: config => createApi(`/tourElder/add`, 'post', config),
	deletetour: config => createApi(`/tourElder/delete`, 'delete', config),
	updatetour: config => createApi(`/tourElder/update`, 'post', config),
	houseList: config => createApi(`/tRealestate/pageSearch`, 'post', config), // 设备列表
}



// WEBPACK FOOTER //
// ./src/views/tourManage/api/index.js